export default "__VITE_ASSET__kCkMZXK9__"